import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from '../pages/auth/AdminLogin';
import { Dashboard, Hotels, HotelDetails, PendingListings } from '../pages';
import Customers from '../pages/Customers';
import EditProperty from '../pages/EditProperty';
import ProtectedRoute from '../components/ProtectedRoute';
import OwnerListings from '../pages/OwnerListings';


const AppRoutes: React.FC = () => {
  return (
    <Routes>

      {/* Auth Routes */}
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/admin-login" element={<AdminLogin />} />

      {/* Protected Routes */}
      <Route
        path="/dashboard"
        element={<ProtectedRoute element={<Dashboard />} />}
      />

      <Route
        path="/hotels"
        element={<Hotels />}
        //element={<ProtectedRoute element={<Hotels />} />}
      />
      <Route
        path="/owner-listings"
        element={<ProtectedRoute element={<OwnerListings />} />}
      />


      <Route
        path="/pending-listings"
        element={<ProtectedRoute element={<PendingListings />} />}
      />

      <Route
        path="/hotels/:id"
        element={<ProtectedRoute element={<HotelDetails />} />}
      />

      {/* NEW EDIT PROPERTY ROUTE */}
      <Route
        path="/properties/edit/:id"
        element={<ProtectedRoute element={<EditProperty />} />}
      />

      <Route
        path="/customers"
        element={<ProtectedRoute element={<Customers />} />}
      />

      {/* Default Route */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />

    </Routes>
  );
};

export default AppRoutes;
